import {
    BrowserRouter as Router,
} from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import AuthProvider from './Providers/AuthProvider'
import 'react-toastify/dist/ReactToastify.css';
import ConfigProvider from './Providers/ConfigProvider';
import '@fontsource/inter';
import { RegistrationProvider } from './Providers/RegistrationProvider';
import { ParamsProvider } from './Providers/ParamsProvider';
import { Notifications } from 'react-push-notification';
import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from './Config/queryClient';

const NewApp = () => {
    return (
        <>
            <Notifications />
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            <QueryClientProvider client={queryClient}>
                <Router>
                    <ConfigProvider>
                        <ParamsProvider>
                            <RegistrationProvider>
                                <AuthProvider />
                            </RegistrationProvider>
                        </ParamsProvider>
                    </ConfigProvider>
                </Router>
            </QueryClientProvider>
        </>
    )
}

export default NewApp